import {lazy} from '@aboutyou/lazy-imports';
import {FooterSkeleton} from '@aboutyou/logic-components';
import {useCurrentPageType} from '@aboutyou/router';
import React, {FC, memo} from 'react';

const LazyFooterDynamic = lazy(
  () =>
    import('@aboutyou/logic-components').then(mod => ({
      default: mod.FooterDynamic,
    })),
  {fallback: <FooterSkeleton />},
);

export const FooterDynamic: FC = memo(function FooterDynamic() {
  // memo is used as the useCurrentPageType is expensive and should not trigger too often
  const isCheckout = useCurrentPageType() === 'checkout';

  return <LazyFooterDynamic hideCategories={isCheckout} />;
});
